import React from 'react';
import { ErrorPage } from './ErrorPage';
import * as Sentry from '@sentry/react';

export class ErrorBoundary extends React.Component {
  constructor(props: any) {
    super(props);
    // initialize the error state
    this.state = { error: null };
  }

  // if an error happened, set the state to true
  static getDerivedStateFromError(error: any) {
    return { error };
  }

  componentDidCatch(error: any, errorInfo: any) {}

  render() {
    const { error } = this.state;
    // if error happened, return a fallback component
    if (error) {
      return (
        <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
          <ErrorPage error={error} />
        </Sentry.ErrorBoundary>
      );
    }

    return (this.props as any).children;
  }
}
